var staticStrLast = 'last'

module.exports = staticStrLast



//////////////////
// WEBPACK FOOTER
// ./node_modules/_xe-utils@3.5.7@xe-utils/staticStrLast.js
// module id = 87
// module chunks = 0 1 2 3 4